import {
  DayCellActiveSeasonalRule,
  PropertySeasonalRule,
  SeasonalCancellationPolicyEntry,
} from 'models/seasonality/SeasonalCancellationPolicy';

export const getActiveSeasonalRulesForDate = (
  rules: PropertySeasonalRule[] | undefined,
  dateStr: string,
): DayCellActiveSeasonalRule[] | undefined => {
  if (!rules?.length) {
    return undefined;
  }
  const active = rules.filter(
    (rule) => rule.startDate <= dateStr && dateStr <= rule.endDate,
  );
  if (!active.length) {
    return undefined;
  }
  return active.map((rule) => ({
    ruleUid: rule.ruleUid,
    color: rule.color,
    isRangeStart: rule.startDate === dateStr,
    isRangeEnd: rule.endDate === dateStr,
  }));
};

export const groupSeasonalCancellationPoliciesByProperty = (
  entries: SeasonalCancellationPolicyEntry[],
): Record<string, PropertySeasonalRule[]> => {
  const propertyMap = new Map<string, Map<string, PropertySeasonalRule>>();

  entries.forEach((entry) => {
    if (!propertyMap.has(entry.propertyUid)) {
      propertyMap.set(entry.propertyUid, new Map());
    }
    const rulesMap = propertyMap.get(entry.propertyUid)!;

    if (!rulesMap.has(entry.ruleUid)) {
      rulesMap.set(entry.ruleUid, {
        ruleUid: entry.ruleUid,
        ruleName: entry.ruleName,
        color: entry.color,
        startDate: entry.startDate,
        endDate: entry.endDate,
        cancellationPolicies: [],
      });
    }

    const rule = rulesMap.get(entry.ruleUid)!;
    const alreadyHasChannel = rule.cancellationPolicies.some(
      (p) => p.channel === entry.channel,
    );
    if (!alreadyHasChannel) {
      rule.cancellationPolicies.push({
        channel: entry.channel,
        policyCode: entry.policyCode,
        displayLabel: entry.displayLabel,
      });
    }
  });

  const result: Record<string, PropertySeasonalRule[]> = {};
  propertyMap.forEach((rulesMap, propertyUid) => {
    result[propertyUid] = Array.from(rulesMap.values());
  });
  return result;
};
